// import React, { useEffect, useLayoutEffect, useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
// import Sidebar from "../components/SidebarComponent/Sidebar/Sidebar";
// import Footer from "../components/footer/Footer";
// import AuthNav from "../components/nav/AuthNav";
// import React, { useState } from 'react';
import { Layout } from "antd";
import { useLayoutEffect, useState } from "react";
import AuthNav from "../components/nav/AuthNav";
import Sidebar from "../components/SidebarComponent/Sidebar/Sidebar";
import { isUserLoggedIn } from "../services/auth/AuthAPI";
import Footer from "../components/footer/Footer";

const { Header, Sider, Content } = Layout;

function AuthLayout(props: any) {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useLayoutEffect(() => {
    const checkUserLogin = async () => {
      // setLoading(true);
      const status = await isUserLoggedIn();

      setIsAuthenticated(status);
      setLoading(false);
    };
    checkUserLogin();
  }, []);

  if (loading) {
    return <>loading</>;
  }

  return isAuthenticated ? (
    <div className="app">
      <AuthNav />
      <Sidebar />
      <Outlet />
      <Footer />
    </div>
  ) : (
    // <Redirect/>
    <Navigate to={"/"} />
  );
}

export default AuthLayout;
